import React from 'react';
import Button from '@atlaskit/button';
import EditFilledIcon from '@atlaskit/icon/glyph/edit-filled';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import messages from './messages';

export type EditProps = Intl & {
	onEditRequested: () => void;
};

const EditView = ({ intl: { formatMessage }, onEditRequested }: EditProps) => (
	<Button
		testId="servicedesk-sla-settings.ui.calendars.editable.fields.holidays.holiday.read-only-view-with-actions.edit.button"
		appearance="subtle"
		iconAfter={<EditFilledIcon size="small" label={formatMessage(messages.edit)} />}
		onClick={onEditRequested}
	/>
);

export const Edit = injectIntl(EditView);
